import Fetcher, { URLBuild } from './fetcher';
import settings from '../settings';


const construt_url = (url: string, params: any) => {
	return URLBuild(settings.strapiAdminApi + url, params);
}

const Strapi = {
	get: async (path: string, params: any = {}, headers: any = {}): Promise<any> => Fetcher.request('GET', construt_url(path, params), null, headers),
	post: async (path: string, params: any = {}, data: any = {}, headers: any = {}): Promise<any> => Fetcher.request('POST', construt_url(path, params), JSON.stringify(data), headers),
	put: async (path: string, params: any = {}, data: any, headers: any = {}): Promise<any> => Fetcher.request('PUT', construt_url(path, params), JSON.stringify(data), headers),
	patch: async (path: string, params: any = {}, data: any, headers: any = {}): Promise<any> => Fetcher.request('PATCH', construt_url(path, params), data, headers),
	delete: async (path: string, params: any = {}, headers: any = {}): Promise<any> => Fetcher.request('DELETE', construt_url(path, params), null, headers),
}

export default Strapi;